import React from "react";

import "./predictionBox.css";
import Moment from "moment";
import AnnouncementBanner from "../../predictionPostponed/predictionPostponed";

const PredictionStat = (prop) => {
  const qust = prop.question[0]
    ? prop.question
    : prop.question.data
      ? prop.question.data
      : [];

  const totalPoints = qust.reduce((acc, item) => acc + item.que_points, 0);

  // Collect unique calendar dates across all questions (same field until API is ready)
  const uniqueDates = qust.length
    ? [
        ...new Set(
          qust
            .filter((item) => typeof item.que_time_qatar_string === "string")
            .map((item) =>
              Moment(item.que_time_qatar_string, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD"),
            ),
        ),
      ].sort()
    : [];

  let dateDisplay = "";
  if (uniqueDates.length > 1) {
    const d1 = Moment(uniqueDates[0], "YYYY-MM-DD");
    const d2 = Moment(uniqueDates[uniqueDates.length -1], "YYYY-MM-DD");
    dateDisplay = `${d1.format("DD MMM")} - ${d2.format("DD MMM")}`;
  } else if (uniqueDates.length === 1) {
    dateDisplay = Moment(uniqueDates[0], "YYYY-MM-DD").format("DD MMM YYYY");
  }

  const matchDate = prop.question[0]
    ? Moment(prop.question[0].que_time_qatar_string, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD")
    : null;
  const vle = matchDate && prop.matchDays ? prop.matchDays.find((item) => item.date == matchDate) : null;
  const day = vle?.is_match_day ? vle.day : "";

  if (!dateDisplay.length) return; 

  return (
    <>
      {prop.isPostponed && <AnnouncementBanner />}
      <div className="predictionStat">
        <div className="predictionStat-wrapper">
          {day ? (
            <div className="predictionStat-part1">
              <div className="predictionStat-title">
                <p>Match Day</p>
              </div>
              <div className="predictionStat-info">
                <p className="count">{day}</p>
              </div>
            </div>
          ) : (
            ""
          )}
          <div className="predictionStat-part1">
            <div className="predictionStat-title">
              <p>Date</p>
            </div>
            <div className="predictionStat-info">
              <p className="count">
                {prop.isPostponed ? "TBD" : dateDisplay}
              </p>
            </div>
          </div>
          <div className="predictionStat-part2">
            <div className="predictionStat-title">
              <p>Total Qns</p>
            </div>
            <div className="predictionStat-info">
              <p className="count">{prop.question.length}</p>
            </div>
          </div>
          <div className="predictionStat-part3">
            <div className="predictionStat-title">
              <p>Total Pts</p>
            </div>
            <div className="predictionStat-info">
              <p className="count">{totalPoints}</p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PredictionStat;
